<template>
  <div class="signup-review">
    <h1>Pending Signup Requests</h1>
    <p v-if="statusMessage" :class="['status', statusType]">{{ statusMessage }}</p>
<div class="approval-reminder">
  <strong>Note:</strong> After approving a signup request, the user will automatically receive an invite email so they can set up their username and password. 
</div>

    <table v-if="requests.length">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>DOB</th>
          <th>Country</th>
          <th>Use</th>
          <th>LE?</th>
          <th>Referral</th>
    <th>Promo</th> <!-- NEW -->
          <th>IP</th>
          <th>User Agent</th>
          <th>Submitted</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="req in requests" :key="req.id">
          <td>{{ req.first_name }} {{ req.last_name }}</td>
          <td>{{ req.email }}</td>
          <td>{{ req.dob }}</td>
          <td>{{ req.country }}</td>
          <td>{{ req.intended_use || '—' }}</td>
          <td>{{ req.law_enforcement_flag ? '✅' : '❌' }}</td>
          <td>{{ req.referral_code || '—' }}</td>
            <td>
      <span v-if="req.promo_code" class="badge badge--promo">{{ req.promo_code }}</span>
      <span v-else>—</span>
    </td>
          <td>{{ req.ip_address }}</td>
          <td><small>{{ req.user_agent }}</small></td>
          <td>{{ formatTime(req.timestamp) }}</td>
        <td>
  <template v-if="pendingApproveId === req.id">
    <button @click="confirmApprove(req.id)" class="approve-btn">Confirm</button>
    <button @click="pendingApproveId = null" class="approve-btn cancel-btn">Cancel</button>
  </template>
  <button
    v-else
    @click="pendingApproveId = req.id"
    class="approve-btn"
  >
    Approve
  </button>

  <template v-if="pendingRejectId === req.id">
    <button @click="confirmReject(req.id)" class="reject-btn" style="margin-left: 6px;">Confirm</button>
    <button @click="pendingRejectId = null" class="reject-btn" style="margin-left: 4px;">Cancel</button>
  </template>
  <button
    v-else
    @click="pendingRejectId = req.id"
    class="reject-btn"
    style="margin-left: 6px;"
  >
    Reject
  </button>
</td>


        </tr>
      </tbody>
    </table>
<div v-if="total > limit" class="pagination">
  <button @click="prevPage" :disabled="page === 1">Prev</button>
  Page {{ page }} of {{ Math.ceil(total / limit) }}
  <button @click="nextPage" :disabled="page * limit >= total">Next</button>
</div>

 <p v-if="!requests.length && total === 0">No pending requests.</p>

<router-link to="/signuphistory">Signup History</router-link><br/>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SignupReview',
data() {
  return {
    requests: [],
    statusMessage: '',
    statusType: '',
    pendingRejectId: null, // Track which ID is pending confirmation
    pendingApproveId: null,
    page: 1,
    limit: 25,
    total: 0
  };
},

  mounted() {
    this.fetchRequests();
  },
  methods: {
    fetchRequests() {
    axios.get(`/etherscan/fetch_pending_signups.php?page=${this.page}&limit=${this.limit}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
    .then(res => {
      if (res.data.status === 'success') {
        this.requests = res.data.requests;
        this.total = res.data.total;
      } else {
        this.statusMessage = res.data.message;
        this.statusType = 'error';
      }
    })
    .catch(() => {
      this.statusMessage = 'Failed to load signups.';
      this.statusType = 'error';
    });
  },
  nextPage() {
    if (this.page * this.limit < this.total) {
      this.page++;
      this.fetchRequests();
    }
  },
  prevPage() {
    if (this.page > 1) {
      this.page--;
      this.fetchRequests();
    }
},
    
   confirmReject(id) {
  axios.post('/etherscan/reject_signup.php', { id }, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  })
  .then(res => {
    if (res.data.status === 'success') {
      this.statusMessage = 'Signup request rejected.';
      this.statusType = 'success';
      this.pendingRejectId = null;
      this.fetchRequests();
    } else {
      this.statusMessage = res.data.message;
      this.statusType = 'error';
    }
  })
  .catch(() => {
    this.statusMessage = 'Rejection failed.';
    this.statusType = 'error';
  });
}

,
    confirmApprove(id) {
    axios.post('/etherscan/approve_signup.php', { signup_id: id }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
    .then(res => {
      if (res.data.status === 'success') {
        this.statusMessage = 'Signup request approved.';
        this.statusType = 'success';
        this.pendingApproveId = null;
        this.fetchRequests();
      } else {
        this.statusMessage = res.data.message;
        this.statusType = 'error';
      }
    })
    .catch((err) => {
      this.statusMessage = 'Approval failed.';
      console.log(err);
      this.statusType = 'error';
    });
  },
    formatTime(iso) {
      return new Date(iso).toLocaleString();
    }
  }
};
</script>

<style scoped>
.signup-review {
  max-width: 1100px;
  margin: 0 auto;
}
table {
  width: 100%;
  border-collapse: collapse;
}
th, td {
  border: 1px solid #ccc;
  padding: 6px;
  font-size: 13px;
}
.status.success {
  color: green;
}
.status.error {
  color: red;
}
button {
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
}
button.reject-btn {
  background-color: #f8d7da;
  color: #a94442;
  border: 1px solid #e74c3c;
}
button.reject-btn:hover {
  background-color: #f5c6cb;
}
.pagination {
  margin-top: 10px;
  text-align: center;
}
.pagination button {
  margin: 0 8px;
  padding: 6px 10px;
  font-size: 13px;
}
.approval-reminder {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  padding: 10px 14px;
  border-radius: 6px;
  margin-bottom: 16px;
  font-size: 14px;
}
.badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1;
  border: 1px solid #ccc;
}
.badge--promo {
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #096dd9;
}

</style>
